export const color = {
    // Primary Palette

    StarRezBrandColors: {
        Blue60: '#0076E0',
        Grey30: '#DAE5EC',
        Grey80: '#12374E',
        WhiteSR: 'white',
        YellowSR: '#FFF100',
    },

    Grey: {
        G100: '#020F18',
        G90: '#072131',
        // tslint:disable-next-line: object-literal-sort-keys
        G80: '#12374E',
        G70: '#516878',
        G60: '#6D748D',
        G50: '#C4C9D2',
        G40: '#C8D3DA',
        G30: '#DAE5EC',
        G20: '#EDF2F5',
        G10: '#F6F8FA',
    },

    // Secondary Palette

    Blue: {
        B100: '#00398D',
        B80: '#0341E0',
        // tslint:disable-next-line: object-literal-sort-keys
        B60: '#0075DB',
        B40: '#B4E1FA',
        B20: '#EBF6FF',
    },
    Green: {
        G100: '#003A1B',
        G80: '#038215',
        // tslint:disable-next-line: object-literal-sort-keys
        G60: '#50B83C',
        G40: '#BBE5B3',
        G20: '#E3F1DF',
    },
    Orange: {
        O100: '#4A1504',
        O80: '#C05717',
        // tslint:disable-next-line: object-literal-sort-keys
        O60: '#FB7C39',
        O40: '#FFC58B',
        O20: '#FCEBDB',
    },
    Pink: {
        P100: '#58002C',
        P80: '#A21950',
        // tslint:disable-next-line: object-literal-sort-keys
        P60: '#D22866',
        P40: '#FEA0C0',
        P20: '#FFCFE2',
    },
    Purple: {
        P100: '#1F0481',
        P80: '#4319D6',
        // tslint:disable-next-line: object-literal-sort-keys
        P60: '#6A43F3',
        P40: '#DED6FC',
        P20: '#F6F0FD',
    },
    Red: {
        R100: '#4F0407',
        R80: '#A5191F',
        // tslint:disable-next-line: object-literal-sort-keys
        R60: '#E1272F',
        R40: '#FEAD9A',
        R20: '#FBEAE5',
    },
    Teal: {
        T100: '#003135',
        T80: '#00828C',
        // tslint:disable-next-line: object-literal-sort-keys
        T60: '#47C1BF',
        T40: '#B7ECEC',
        T20: '#E0F5F5',
    },
    Yellow: {
        Y100: '#573B00',
        Y80: '#8A6116',
        // tslint:disable-next-line: object-literal-sort-keys
        Y60: '#EEC200',
        Y40: '#FFF0B3',
        Y20: '#FFFBEC',
    },
};
